var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9084 8.18469L23.8159 10.0922C24.0615 10.3384 24.0615 10.7072 23.8159 10.9541L18.0926 16.6773C18.0314 16.7392 17.9695 16.8004 17.9083 16.8004H17.847L14.9545 17.7848C14.8933 17.846 14.8314 17.846 14.7702 17.846C14.5858 17.846 14.4627 17.7848 14.3395 17.6617C14.2164 17.5385 14.1551 17.2923 14.2164 17.046L15.2008 14.1535V14.0923C15.2319 14.0615 15.2473 14.0306 15.2628 13.9996C15.2781 13.969 15.2934 13.9384 15.3239 13.9079L21.0471 8.18469C21.2927 7.93844 21.6621 7.93844 21.9084 8.18469ZM22.2162 10.8303L22.5237 10.5228L21.4774 9.47656L21.1699 9.78407L22.2162 10.8303ZM17.6615 15.3842L16.6159 14.3386L20.3084 10.6461L21.3546 11.6923L17.6615 15.3842ZM16.0001 15.5073L15.7539 16.2461L16.4926 15.9998L16.0001 15.5073Z",
    fill: "#116F9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9233 16.6154C20.5539 16.6154 20.3076 16.8616 20.3076 17.231V21.5386C20.3076 22.2154 19.7539 22.7692 19.077 22.7692H10.4613C9.78441 22.7692 9.23066 22.2154 9.23066 21.5386V12.9228C9.23066 12.246 9.78441 11.6922 10.4613 11.6922H14.7688C15.1382 11.6922 15.3845 11.4459 15.3845 11.0766C15.3845 10.7072 15.1382 10.4609 14.7688 10.4609H10.4613C9.10754 10.4609 8 11.5691 8 12.9229V21.5386C8 22.8923 9.10751 23.9999 10.4613 23.9999H19.077C20.4308 23.9999 21.5383 22.8924 21.5383 21.5386V17.231C21.5389 16.861 21.2927 16.6154 20.9233 16.6154L20.9233 16.6154Z",
    fill: "#116F9A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 1.5,
    stroke: "#C6C2C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c5f28cb474df8e47b09306e90706e06d.svg";
export { ForwardRef as ReactComponent };